module.exports = __webpack_public_path__ + "img/looney-sign-up-form.55b965d4.svg";